import { FULL } from './values';
import prepareOptions from '../../prepareOptions';

export default prepareOptions([
  {
    value: FULL,
    label: __('carDetails.imageCaption.serviceBook'),
  },
]);
